<template>
  <h2 class="text-center">Customization is temporarily unavailable.</h2>
</template>

<script>
export default {
  name: "NotFound"
}
</script>
